import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DataService } from '../data.service';
import { OTPChallengeResponse } from '../models/otpChallengeResponse';
import { OTPValidationRequest } from '../models/otpValidationRequest';
import { ClaimElevationRequest } from '../models/claimElevationRequest';
import { LoginResponseModel } from '../models/loginResponseModel';
import { Location } from '@angular/common';
import { CardBearerModel } from '../models/cardBearerModel';
import { AadhaarLoginModel, LoginModel } from '../models/loginModel';
import { JsonConvert } from 'json2typescript';
import { AadhaarOtpVerificationResponse } from '../models/aadhaarOtpVerificationResponse';
import { AadharOTPValidationRequest } from '../models/aadhaarOtpVerificationRequest';

@Component({
  selector: 'app-aadhaar-otp',
  templateUrl: './aadhaar-otp.component.html',
  styleUrls: ['./aadhaar-otp.component.scss']
})
export class AadhaarOtpComponent implements OnInit {

  constructor(private route: ActivatedRoute,
private router: Router,private data: DataService,  private location: Location) {

    var logind = JSON.parse(this.route.snapshot.paramMap.get("logindata"));
    console.log(logind);
    this.logindata = logind;

 }

  public showSubmitButton = true;

  public logindata: AadhaarLoginModel;

  public req: AadharOTPValidationRequest = new AadharOTPValidationRequest();

  public errMessage: string = "";



  ngOnInit(): void {


  }

  
  onOtpSubmit(): void {
    //Validate the data first
    this.errMessage = "";
    if (!this.validate()) {
      return;
    }


    this.req.UUID = this.logindata.uuid;
    this.req.Aadharnumber = this.logindata.aadhaar;
    this.logindata.otp = this.req.Otp;
    this.req.PropertyCardNumber = this.logindata.cardnumber;
    this.req.UserId = this.logindata.userid;


    this.showSubmitButton = false;

    this.data.request<LoginResponseModel>("aadhaarlogin", this.req, "POST").subscribe((v) => {

      this.data.token = v.token;
      this.data.isLoggedIn = true;
      this.data.SelectedCardBearerID = this.logindata.userid;


      this.data.RaiseEvent("login");
      this.router.navigate(['loadingprogress'],{skipLocationChange:true});


      //No need to elevate the token as the token comes already elevated
      //this.elevateToken();
    },
      (error) => {
        this.errMessage = "Failed to verify, please try again."
        this.showSubmitButton = true;

      },() => {
        this.showSubmitButton = true;
      });
  }

  validate(): boolean {
    if (!new RegExp('^[0-9]{6}$').test(this.req.Otp)) {
      this.errMessage = "6 digit pin is required";
      return false;
    } else {
      return true;
    }
  }

  /*
  elevateToken() {
    var r: ClaimElevationRequest = new ClaimElevationRequest();
    r.ChallengeKey = this.req.id;
    this.data.request<LoginResponseModel>("auth/refresh_token", this.req, "POST").subscribe((v) => {
      this.data.token = v.token;
      this.data.isLoggedIn = true;


      this.data.RaiseEvent("login");
      this.router.navigate(['loadingprogress'], { skipLocationChange: true });
    },
      (error) => {
        this.errMessage = "Failed to validate the OTP, please try again."
      });
  }*/

  onRetry(): void {
    this.router.navigate([''], { skipLocationChange: true });
  }

}
